const Var = {
  get: function(obj, keys, dft) {
    if (!['object', 'array'].includes(typeof obj) || obj === null) return dft
    keys = Array.isArray(keys)
      ? keys
      : keys.replace(/(\[(\d)\])/g, '.$2').split('.')
    obj = obj[keys[0]]
    if (obj && keys.length > 1) {
      return this.get(obj, keys.slice(1), dft)
    }
    return obj === undefined ? dft : obj
  },

  set: function(obj, path, val) {
    let keys = Array.isArray(keys)
      ? keys
      : keys.replace(/(\[(\d)\])/g, '.$2').split('.')
    if (keys.length > 1) {
      obj[keys[0]] = obj[keys[0]] || {}
      return this.set(obj[keys[0]], keys.slice(1), val)
    }
    obj[keys[0]] = val
  },

  getInt: function(obj, keys, dft) {
    let val = Var.get(obj, keys, dft)
    val = parseInt(val)
    return val !== NaN ? val : dft
  },

  getString: function(obj, keys, dft) {
    let val = Var.get(obj, keys, dft)
    if (val === null) val = ''
    return val.toString()
  },

  // định dạng kiểu số, tiền tệ
  format: function(number, n, x, s, c) {
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
      num = parseInt(number).toFixed(Math.max(0, ~~n))

    return (c ? num.replace('.', c) : num).replace(
      new RegExp(re, 'g'),
      '$&' + (s || ',')
    )
  },

  // tính kích thước trên RAM của một biến bất kì
  size: function(obj) {
    var bytes = 0

    function sizeOf(obj) {
      if (obj !== null && obj !== undefined) {
        switch (typeof obj) {
          case 'number':
            bytes += 8
            break
          case 'string':
            bytes += obj.length * 2
            break
          case 'boolean':
            bytes += 4
            break
          case 'object':
            var objClass = Object.prototype.toString.call(obj).slice(8, -1)
            if (objClass === 'Object' || objClass === 'Array') {
              for (var key in obj) {
                if (!obj.hasOwnProperty(key)) continue
                sizeOf(obj[key])
              }
            } else bytes += obj.toString().length * 2
            break
        }
      }
      return bytes
    }

    function formatByteSize(bytes) {
      if (bytes < 1024) return bytes + ' bytes'
      else if (bytes < 1048576) return (bytes / 1024).toFixed(3) + ' KiB'
      else if (bytes < 1073741824) return (bytes / 1048576).toFixed(3) + ' MiB'
      else return (bytes / 1073741824).toFixed(3) + ' GiB'
    }

    return formatByteSize(sizeOf(obj))
  }
}

export default Var
